import { getGameId } from "Helpers/Utilieties";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const notifyParent = (navType = "PUSH", path = null) => {
  window.parent.postMessage(
    {
      action: "CHILD_ROUTE_CHANGE",
      game_id: getGameId(),
      navigationType: navType,
      isReplace: navType === "REPLACE",
      path: path || (window.location.pathname + window.location.search + window.location.hash),
    },
    "*" // ideally use parent origin
  );
};
export const useNotifyParentOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    const notifyParent = (navType = "PUSH") => {
      window.parent.postMessage(
        {
          action: "CHILD_ROUTE_CHANGE",
          path: window.location.pathname + window.location.search + window.location.hash,
          navigationType: navType,
          isReplace: navType === "REPLACE",
          game_id: getGameId()
        },
        "*" // ideally use parent origin
      );
    };

    // ✅ Fire initially on mount (once)
    notifyParent("LOAD");

    // ✅ React Router navigation detection
    notifyParent("PUSH");

    // ✅ Native history method patch (pushState / replaceState)
    const patchHistory = (methodName) => {
      const original = window.history[methodName];
      return function (...args) {
        const result = original.apply(this, args);
        const navType = methodName === "replaceState" ? "REPLACE" : "PUSH";
        notifyParent(navType);
        return result;
      };
    };

    window.history.pushState = patchHistory("pushState");
    window.history.replaceState = patchHistory("replaceState");

    // ✅ popstate for back/forward
    const handlePopState = () => notifyParent("POP");
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location]);
};